<form (ngSubmit)="onSubmit()" [formGroup]="registerForm">
  <label>
    <span class="label-content">
      {{ 'verificationTokenForm.verificationCode.label' | cxTranslate }}
      <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template
    ></span>
    <input
      required="true"
      class="form-control"
      formControlName="tokenCode"
      placeholder="{{
        'verificationTokenForm.verificationCode.placeholder' | cxTranslate
      }}"
    />
    <cx-form-errors [control]="registerForm.get('tokenCode')"></cx-form-errors>
    <div class="rate-limit-error-display" *ngIf="upToRateLimit">
      {{
        'register.rateLimitForRegistrationMessage'
          | cxTranslate: { seconds: waitTimeForRateLimit }
      }}
    </div>
  </label>

  <input type="hidden" formControlName="tokenId" [(ngModel)]="tokenId" />

  <div *ngIf="!upToRateLimit" class="resend-link-text">
    <div class="left-text">
      <span role="timer" aria-live="polite" aria-atomic="true">
        <a
          role="button"
          tabindex="-1"
          #resendLink
          (keydown.enter)="resendOTP()"
          (keydown.space)="resendOTP()"
          (click)="resendOTP()"
          class="btn-link"
          [ngClass]="{ 'disabled-link': isResendDisabled }"
        >
          {{ 'verificationTokenForm.resend' | cxTranslate }}
        </a>
        <ng-container *ngIf="isResendDisabled">
          {{
            'verificationTokenForm.sendRateLime'
              | cxTranslate: { waitTime: waitTime }
          }}
        </ng-container>
      </span>
    </div>
    <div class="right-text">
      <a
        role="button"
        tabindex="0"
        #noReceiveCodeLink
        (keydown)="onOpenInfoDailogKeyDown($event)"
        (click)="openInfoDailog()"
        class="btn-link"
      >
        {{ 'verificationTokenForm.noReceiveCode' | cxTranslate }}
      </a>
    </div>
  </div>

  <div class="form-group">
    <label>
      <span class="label-content"
        >{{ 'register.password.label' | cxTranslate }}
        <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template
      ></span>
      <input
        required="true"
        class="form-control"
        type="password"
        name="password"
        placeholder="{{ 'register.password.placeholder' | cxTranslate }}"
        formControlName="password"
        [attr.aria-label]="'register.password.placeholder' | cxTranslate"
        aria-describedby="password-input-hint"
        cxPasswordVisibilitySwitch
      />
      <p class="input-hint" id="password-input-hint">
        {{ 'register.passwordMinRequirements' | cxTranslate }}
      </p>

      <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->
      <cx-form-errors
        *cxFeature="'formErrorsDescriptiveMessages'"
        [translationParams]="{
          label: 'register.password.label' | cxTranslate,
        }"
        [control]="registerForm.get('password')"
      ></cx-form-errors>

      <cx-form-errors
        *cxFeature="'!formErrorsDescriptiveMessages'"
        [control]="registerForm.get('password')"
      ></cx-form-errors>
    </label>
  </div>

  <div class="form-group">
    <label>
      <span class="label-content"
        >{{ 'register.confirmPassword.label' | cxTranslate }}
        <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template
      ></span>
      <input
        required="true"
        class="form-control"
        type="password"
        name="confirmpassword"
        placeholder="{{ 'register.confirmPassword.placeholder' | cxTranslate }}"
        formControlName="passwordconf"
        [attr.aria-label]="'register.confirmPassword.placeholder' | cxTranslate"
        cxPasswordVisibilitySwitch
      />

      <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->
      <cx-form-errors
        *cxFeature="'formErrorsDescriptiveMessages'"
        [translationParams]="{
          label: 'register.confirmPassword.label' | cxTranslate,
        }"
        [control]="registerForm.get('passwordconf')"
      ></cx-form-errors>

      <cx-form-errors
        *cxFeature="'!formErrorsDescriptiveMessages'"
        [control]="registerForm.get('passwordconf')"
      ></cx-form-errors>
    </label>
  </div>

  <div class="verify-container">
    <button
      type="submit"
      class="btn btn-block btn-primary"
      [disabled]="registerForm.disabled"
    >
      {{ 'register.register' | cxTranslate }}
    </button>
    <button
      [routerLink]="{ cxRoute: 'register' } | cxUrl"
      class="btn btn-block btn-secondary btn-register"
    >
      {{ 'verificationTokenForm.back' | cxTranslate }}
    </button>
  </div>
</form>

<ng-template #requiredAsterisk>
  <abbr
    *cxFeature="'a11yRequiredAsterisks'"
    aria-hidden="true"
    class="text-decoration-none required-asterisk"
    title="{{ 'common.required' | cxTranslate }}"
    >*</abbr
  >
</ng-template>

<ng-template #loading>
  <div class="cx-spinner"><cx-spinner></cx-spinner></div>
</ng-template>
